import { render, staticRenderFns } from "./_Dropdown_sb.vue?vue&type=template&id=0fd0713b&scoped=true&"
import script from "./_Dropdown_sb.vue?vue&type=script&lang=js&"
export * from "./_Dropdown_sb.vue?vue&type=script&lang=js&"
import style0 from "./_Dropdown_sb.vue?vue&type=style&index=0&id=0fd0713b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0713b",
  null
  
)

export default component.exports